import React, { useEffect, useState } from 'react';
import { Tag } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { fetchWithAuth } from '../services/auth';
import { API_BASE } from '../config';

type Stats = { today: number; total: number };

// Информационный тег посетителей svecha.am (визит > 5 сек, уникальные за день).
const VisitorTag: React.FC = () => {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await fetchWithAuth(`${API_BASE}/visit/stats`);
        if (res.ok && alive) setStats(await res.json());
      } catch { /* счётчик некритичен */ }
    };
    load();
    const id = setInterval(load, 60_000); // обновляем раз в минуту
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!stats) return null;

  return (
    <Tag
      icon={<TeamOutlined />}
      color="blue"
      style={{ fontSize: 13, padding: '4px 12px', margin: 0, borderRadius: 6 }}
    >
      Сегодня: {stats.today.toLocaleString('ru-RU')} · Всего: {stats.total.toLocaleString('ru-RU')}
    </Tag>
  );
};

export default VisitorTag;
